import type { RadioCardOption } from '@/shared/components/form-fields';

/** Variações do cartão parcelado. Os custos são os de referência registrados no BFF. */
export const CARD_BILLING_MODE_OPTIONS: RadioCardOption[] = [
  {
    value: 'PER_INSTALLMENT',
    label: 'Link por parcela (padrão)',
    description:
      'Cada parcela é uma compra à vista no cartão. Custo de referência ≈ 3,99% por transação.',
  },
  {
    value: 'SINGLE_TRANSACTION',
    label: 'One shot',
    description:
      'Um link com o total, parcelado em até 12× no cartão. A apólice é emitida em parcela única. Custo de referência ≈ 11,29% em 10×.',
  },
];

/** Variações do PIX parcelado. */
export const PIX_BILLING_MODE_OPTIONS: RadioCardOption[] = [
  {
    value: 'SCHEDULED',
    label: 'PIX por link (padrão)',
    description:
      'Um link de PIX por parcela, enviado por e-mail antes de cada vencimento.',
  },
  {
    value: 'AUTOMATIC',
    label: 'PIX Automático',
    description:
      'O segurado autoriza uma vez no app do banco e as parcelas são debitadas sozinhas. Exige a conta do segurado na proposta.',
  },
];

export const METHOD_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Ativa' },
  { value: 'INACTIVE', label: 'Inativa' },
];
